import React, { useEffect, useState } from "react";
import { Flex, Flex1, Flex5 } from "../../../../../../common/style";
import Button from "@atlaskit/button/new";
import CustomFieldSelectList from "../../CustomFieldSelectList";
import { isEmptyJsonObject } from "../../../../../../common/utils/helper";
import CustomFieldInputRow from "./CustomFieldInputRow";
import { NON_EDITABLE } from "../../../jira.util";
import DescriptionBox from "./DescriptionBox";

function CustomFieldTable({ body, update, isCreateForm }) {
  const [removedOptions, setRemovedOptions] = useState([]);
  const [selectedCf, setSelectedCf] = useState("");

  // Initialize removed options when the component mounts or when body.fields changes
  useEffect(() => {
    const initializeRemovedOptions = () => {
      if (body && body.fields) {
        const existingFields = Object.keys(body.fields);
        const defaultFields = isCreateForm
          ? ["summary", "description", "project", "issuetype", ...NON_EDITABLE]
          : ["project", ...NON_EDITABLE];
        setRemovedOptions([...existingFields, ...defaultFields]);
      }
    };

    initializeRemovedOptions();
  }, [body, isCreateForm]);

  const onCustomFieldSelect = (selectedFieldObject) => {
    setSelectedCf(selectedFieldObject);
  };

  const onAdd = () => {
    if (selectedCf && !body.fields.hasOwnProperty(selectedCf.value)) {
      const updatedBody = { ...body, fields: { ...body.fields, [selectedCf.value]: "" } };
      update(updatedBody);
      setRemovedOptions([...removedOptions, selectedCf.value]);
      setSelectedCf(""); // Clear the selection after adding
    }
  };

  const renderFieldInput = () => {
    if (isEmptyJsonObject(body.fields)) {
      return null;
    }

    return Object.entries(body.fields).map(([key, value]) => {
      if (isCreateForm && !["project", "issuetype", "summary", "description"].includes(key)) {
        return <CustomFieldInputRow field={[key, value]} key={key} update={update} body={body} />;
      }

      if (!isCreateForm && key !== "project") {
        if (key === "description") {
          return <DescriptionBox key={key} update={update} currentBody={body} />;
        } else {
          return <CustomFieldInputRow field={[key, value]} key={key} update={update} body={body} />;
        }
      }

      return null;
    });
  };

  return (
    <>
      {renderFieldInput()?.length > 0 ? (
        renderFieldInput()
      ) : (
        <center>
          Empty fields list.
          <br /> Select the field and click add.
        </center>
      )}
      <hr />
      <Flex>
        <Flex5>
          <CustomFieldSelectList onSelectField={onCustomFieldSelect} removedOptions={removedOptions} />
        </Flex5>
        <Flex1>
          &nbsp;&nbsp;
          <Button appearance="primary" onClick={onAdd} isDisabled={!selectedCf}>
            Add
          </Button>
        </Flex1>
      </Flex>
    </>
  );
}

export default CustomFieldTable;
